<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      custom-class
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('SeaExport.checkGoods')"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row row-grid">
        <cargo-ag-grid
          config-module="130133"
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'100%',height:'450px'}"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'CheckTheGoodsWindow',
  props: {
    visible: { type: Boolean, required: true },
    resultList: { type: Array, required: true, default: () => [] }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: 'SKU ' + this.$t('SeaExport.Code3'), field: 'skuNo', width: 150 },
        { headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'), field: 'cName', width: 150 },
        { headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'), field: 'eName', width: 150 },
        { headerName: 'MFG' + this.$t('SeaExport.NO'), field: 'mfg', width: 150 },
        { headerName: this.$t('SeaExport.Quantity'), field: 'quantity', width: 150 },
        { headerName: 'hS Code', field: 'hsCode', width: 150 }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      this.rowData = this.resultList
    }
  }
}
</script>

<style lang="scss">
.el-loading-mask.is-fullscreen {
  z-index: 999999 !important;
}
</style>

